import { useDashboard } from '../../context/DashboardContext';

/**
 * DashboardTabBar — 48px tab navigation below the header.
 *
 * Tabs:
 * - Übersicht       → active, selectable (dashboardTab = 'uebersicht')
 * - Pflegekalender  → disabled in MVP (placeholder)
 * - Mein Garten     → switches to editor view
 *
 * ARIA: role="tablist" on container, role="tab" + aria-selected on each button.
 */
const DashboardTabBar = () => {
  const { dashboardTab, setDashboardTab, setActiveView } = useDashboard();

  return (
    <div
      role="tablist"
      aria-label="Dashboard Navigation"
      className="hidden md:flex items-end h-12 px-4 bg-gray-50 border-b border-gray-200 flex-shrink-0"
    >
      {/* Übersicht */}
      <button
        type="button"
        role="tab"
        aria-selected={dashboardTab === 'uebersicht'}
        onClick={() => setDashboardTab('uebersicht')}
        className={`px-4 py-3 text-sm font-medium border-b-2 transition-colors ${
          dashboardTab === 'uebersicht'
            ? 'border-emerald-500 text-emerald-600'
            : 'border-transparent text-gray-500 hover:text-gray-700'
        }`}
      >
        Übersicht
      </button>

      {/* Pflegekalender */}
      <button
        type="button"
        role="tab"
        aria-selected={dashboardTab === 'pflegekalender'}
        onClick={() => setDashboardTab('pflegekalender')}
        className={`px-4 py-3 text-sm font-medium border-b-2 transition-colors ${
          dashboardTab === 'pflegekalender'
            ? 'border-emerald-500 text-emerald-600'
            : 'border-transparent text-gray-500 hover:text-gray-700'
        }`}
      >
        Pflegekalender
      </button>

      {/* Mein Garten — navigates to editor */}
      <button
        type="button"
        role="tab"
        aria-selected={false}
        onClick={() => setActiveView('editor')}
        className="px-4 py-3 text-sm font-medium border-b-2 border-transparent text-gray-500 hover:text-gray-700 transition-colors"
      >
        Mein Garten
      </button>
    </div>
  );
};

export default DashboardTabBar;
